import { render, staticRenderFns } from "./ChangeAplWindow.vue?vue&type=template&id=6b7015d0&"
import script from "./ChangeAplWindow.vue?vue&type=script&lang=js&"
export * from "./ChangeAplWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports